import { PermissionsCenterFeature } from '@cast/types-permissions-center';

export const CLOUD_PROVIDER_URL_PARAM_NAME = 'cloudProvider';
export const FEATURES_URL_PARAM_NAME = 'features';

export const FEATURES_ORDER: PermissionsCenterFeature['type'][] = [
  'CLOUD_CONNECT',
  'NODE_AUTOSCALING',
  'APA',
  'OMNI',
  'DBO',
  'KIMCHI',
];
